export default [
  {
    key: 'AddAccountModal',
    getComponent: () => import('./add-account-modal'),
    width: 600,
    maskClosable: false,
    wrapClassName: 'vertical-center-modal'
  },
  {
    key: 'QueryBankStatementModal',
    getComponent: () => import('./query-bank-statement-modal'),
    width: 600
    //maskClosable: false,
  },
  {
    key: 'ChanpaySuccessModal',
    getComponent: () => import('./chanpay-success-modal'),
    width: 400,
    maskClosable: false,
    wrapClassName: ''
  }
]
